import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"
import TomSelect from "tom-select"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.tomSelect = new TomSelect(this.element, {
      create: false,
      maxItems: 1,
      maxOptions: 20,
      searchField: [],
      closeAfterSelect: true,
      placeholder: "Find a user…",
      loadThrottle: 250,
      shouldLoad: query => query.trim().length >= 3,
      onType: () => {
        this.abortController?.abort()
        this.tomSelect.clearOptions()
      },
      load: (query, callback) => this.loadUsers(query, callback),
      onChange: value => {
        const option = this.tomSelect.options[value]
        if (option?.url) Turbo.visit(option.url)
      },
      render: {
        not_loading: () => '<div class="px-3 py-2 text-sm text-stone-500">Type at least 3 characters to find a user.</div>',
        no_results: () => '<div class="px-3 py-2 text-sm text-stone-500">No matching users found.</div>'
      }
    })
  }

  disconnect() {
    this.abortController?.abort()
    this.tomSelect?.destroy()
  }

  async loadUsers(query, callback) {
    this.abortController?.abort()
    const request = new AbortController()
    this.abortController = request
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("q", query.trim())
    try {
      const response = await fetch(url, { headers: { Accept: "application/json" }, signal: request.signal })
      if (!response.ok) throw new Error("User search failed")
      const users = await response.json()
      callback(request.signal.aborted ? [] : users)
    } catch {
      callback()
    }
  }
}
